import React from 'react';
import Modal from "@material-ui/core/Modal";
import {Fade } from '@material-ui/core';

const EndOfYearModal = ({ modalOpen, setModalOpen }) => {
  const modalStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const paperStyle = {
    backgroundColor: '#fff',
    border: 'none',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    padding: '32px 48px',
    maxWidth: '600px',
    width: '90%',
    textAlign: 'center',
    borderRadius: '10px',
  };

  const titleStyle = {
    marginBottom: '16px',
    fontWeight: '600',
    fontSize: '24px',
  };

  const contentStyle = {
    marginBottom: '32px',
    fontSize: '16px',
    lineHeight: '1.5',
  };

  const buttonStyle = {
    marginTop: '16px',
    padding: '10px 20px',
    backgroundColor: '#3f51b5', // Primary color like Material-UI
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
  };


  return (
    <Modal
      aria-labelledby="end-of-year-modal"
      aria-describedby="end-of-year-description"
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      style={modalStyle} // Use inline style for the Modal
      closeAfterTransition

    >
      <Fade in={modalOpen}>
        <div style={paperStyle}>
          <h2 id="end-of-year-modal" style={titleStyle}>
            Attention
          </h2>
          <p id="end-of-year-description" style={contentStyle}>
            Projects will become inactive if they are not completed within 30 days of registration.
            If an inactive project is completed prior to the end of the year, and funds are available,
            please request that it be updated to "In Progress" so you may submit for review.
          </p>
          <button
            style={buttonStyle}
            onClick={() => setModalOpen(false)}
          >
            Got it!
          </button>
        </div>
      </Fade>
    </Modal>
  );
};

export default EndOfYearModal;
